import { useState } from 'react';
import {
    getPrimaryRole,
    getUserRoleLabel,
    isOrganizationAdministrator,
    isUserAdmin,
} from 'src/domain/user';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';
import cx from 'classnames';
import { AppModal } from 'src/components/Modals/AppModal';
import { UserRound } from 'lucide-react';
import { NavItem } from './NavItem';
import { UserRole } from 'src/domain/user';
import { ScrollableModal } from '../Modals/ScrollableModal';
import { Faq } from 'src/view/screens/Faq';
import { useLogout } from 'src/view/hooks/useLogout';
import { useTranslation } from 'react-i18next';

export const AccountButton = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => setModalOpen(!modalOpen);
    const [showFaq, setShowFaq] = useState(false);
    const user = useSignedInUser();
    const logout = useLogout();
    const { t } = useTranslation();

    if (!user) return null;

    const {
        profile: { firstName, lastName },
    } = user;
    const role = getPrimaryRole(user);
    const isAdmin = isUserAdmin(user);
    const roleLabel = (
        isAdmin
            ? t('roles.admin')
            : isOrganizationAdministrator(user)
            ? t('roles.systemAdmin')
            : getUserRoleLabel(role)
    ).toUpperCase();
    const profileScreen =
        role === UserRole.nextOfKin
            ? '/app/nextofkin-profile'
            : '/app/my-profile';

    const initials = `${firstName.charAt(0)}${lastName.charAt(
        0,
    )}`.toUpperCase();

    const fullName = `${firstName} ${lastName}`;
    return (
        <div className="py-2 " id="Account-btn">
            <ScrollableModal
                visible={showFaq}
                onClose={() => setShowFaq(false)}
            >
                <Faq />
            </ScrollableModal>
            <button
                className={cx(
                    'flex items-center justify-center w-10 h-10 rounded-md text-sm hover:bg-starkWhite hover:text-woodyBrown focus:outline-none transition-all',
                    modalOpen
                        ? 'bg-peachOrange text-woodyBrown '
                        : 'bg-woodyBrown text-lightPeach ',
                )}
                onClick={toggleModal}
            >
                {initials}
            </button>
            <AppModal clickOutside={() => setModalOpen(false)} show={modalOpen}>
                <div className="animate-fade-in-fast origin-top-right z-40 absolute bg-lightPeach py-4 text-woodyBrown w-64 right-[16px]  rounded-[16px] shadow-xl">
                    <div className="inline-flex h-[60px] space-x-[16px]  px-[16px] items-center">
                        <div className="z-10 w-[60px] h-[60px] text-[18px] outline-none  focus:outline-none rounded-[12px] bg-woodyBrown text-lightPeach flex items-center justify-center">
                            {initials}
                        </div>
                        <div className="h-[60px]">
                            <div>
                                <p className="text-[18px] leading-none ">
                                    {fullName}
                                </p>
                                <p className="text-[12px] font-extralight">
                                    {roleLabel}
                                </p>
                            </div>
                            <div className="inline-flex items-center space-x-[4px] mb-[2px] ">
                                <div className="bg-palmleafGreen w-[8px] h-[8px] mt-[2px] rounded-full " />
                                <p className="text-[12px] align-middle leading-none ">
                                    {t('account.loggedIn')}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-[16px]">
                        <NavItem
                            icon={UserRound}
                            screen={profileScreen}
                            onClick={() => setModalOpen(false)}
                            label={t('account.profile')}
                            isLight={true}
                        />
                        {/* <NavItem
                            label={t('account.faq')}
                            icon={QuestionMarkIcon}
                            isLight
                            onClick={() => setShowFaq(true)}
                        /> */}
                    </div>
                    <div className="flex items-center justify-end gap-3 pt-4 px-4">
                        <button
                            className="primary-btn-small flex-grow"
                            onClick={() => {
                                logout();
                                setModalOpen(false);
                            }}
                        >
                            {t('account.logout')}
                        </button>
                    </div>
                </div>
            </AppModal>
        </div>
    );
};
